/* eslint-disable max-lines */
import {
  Colors,
  ThemeComponentColors,
  ThemeProps,
  DarkTheme,
} from "@gf-easy-8/grmnext-foundation";

export type DaatColors = {
  app: {
    background: string;
    color: string;
  };
  global: {
    fadedBlack: string;
  };
};

export type DaatThemeProps = {
  colours: DaatColors & ThemeComponentColors;
} & ThemeProps;

const darkTheme: DaatThemeProps = {
  ...DarkTheme,
  colours: {
    ...DarkTheme.colours,
    app: {
      background: Colors.white,
      color: Colors.black,
    },
    global: {
      fadedBlack: Colors.fadedBlack,
      ...DarkTheme.colours.global,
    },
  },
};

export default darkTheme;
